import React, { Suspense, useCallback, useContext, useEffect, useState } from "react";
import {
	Button,
	Checkbox,
	CheckboxProps,
	Grid,
	IconButton,
	InputAdornment,
	MenuItem,
	Paper,
	Select,
	TextField,
	Typography,
	withStyles
} from "@material-ui/core";

import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import ClearIcon from "@material-ui/icons/Clear";
import EventIcon from "@material-ui/icons/Event";
import { green } from "@material-ui/core/colors";
import UpdateIcon from "@material-ui/icons/Update";

import { UIContext } from "../../../../../contexts";
import { ADMIN_DASHBOARD_HEADER } from "../../../../../constants/caption/dashboardHeader";
import { Providers } from "../../../../../@types/providers.types";
import SnackbarAPICall from "../../../../shared/snackbar/SnackbarAPICall";
import { SnackbarProps } from "../../../../../@types/snackbarAPI.types";
import { DynamicForm } from "../../../../../@types/dynamicForm.types";
import { MaterialUiPickersDate } from "@material-ui/pickers/typings/date";
import { zipToCoordinateConverter } from "../../../../../utils/commonFunctions/zipToCoordinateConverter";
import { handleFaxNumberFormat } from "../../../../../utils/commonFunctions/handleFaxNumber";

import "./editProviders.scss";

const date = new Date();
const maxDateRange = date.setDate(date.getDate());

const GreenCheckbox = withStyles({
	root: {
		color: green[400],
		"&$checked": {
			color: green[600]
		}
	},
	checked: {}
})((props: CheckboxProps) => <Checkbox color="default" {...props} />);

const EditProviders: React.FC = (): JSX.Element => {
	const [providersDetails, setProvidersDetails] = useState<Providers>({
		provider_type: "DIRECT CONTRACT",
		provider_status: "",
		tax_id: "UT0HJGB",
		first_name: "David",
		middle_name: "",
		last_name: "Beckham",
		degree: "N.P",
		contracted_through: "Allegiance Care LLC",
		facility_name: "BSA Hospital LLC",
		speciality: "Podiatry",
		address: "2428 N. Grandview Blvd.",
		city: "Center",
		state: "TX",
		ZIP: "40484",
		latitude: "",
		longitude: "",
		phone_number: "8796541258",
		fax_number: "2264460055",
		effective_date: "09-01-2022",
		termination_date: "09-01-2022",
		fee_schedule: "20",
		office_name: "Doenier Family Medicine"
	});
	const [snackbarAPICallProps, setSnackbarAPICallProps] = useState<SnackbarProps>({
		open: false,
		severity: undefined,
		message: "",
		handleSnackbarClose: (event, reason) => {
			if (reason === "clickaway") return;
			setSnackbarAPICallProps(
				Object.assign({}, snackbarAPICallProps, {
					open: false
				})
			);
		}
	});
	const [providerDetailsForm, setProviderDetailsForm] = useState<DynamicForm>();
	const [pasted, setPasted] = useState<boolean>(false);

	const { setDashboardHeader } = useContext(UIContext);

	const handleEditProvidersSubmitClick = useCallback(() => {
		// console.log("ProviderDetails", providersDetails);
		// handleValidation();
		// console.log("validation", validation.status, validation);
		// if (validation.status === "valid") console.log("ProviderDetails", providersDetails);
		// else alert("Please check the information");
	}, [providersDetails]);

	const handleProviderInputChange = useCallback(
		(event: React.ChangeEvent<HTMLInputElement>) => {
			const { name, value } = event.target;

			if (name === "ZIP") {
				const generatedLatitudeLongitude = zipToCoordinateConverter(value);
				const _latitude = String(generatedLatitudeLongitude[0]);
				const _longitude = String(generatedLatitudeLongitude[1]);
				setProvidersDetails(
					Object.assign({}, providersDetails, { latitude: _latitude, longitude: _longitude })
				);
			} else {
				setProvidersDetails(Object.assign({}, providersDetails, { [name]: value }));
			}
		},
		[providersDetails]
	);

	const handlePaste = (event: React.ClipboardEvent<HTMLInputElement | HTMLDivElement>) => {
		const { name } = event.target as HTMLInputElement;
		setPasted(true);
		setTimeout(() => null, 2000);
	};

	const handleDateInputChange = useCallback(
		(_date: MaterialUiPickersDate, name: string) => {
			const date = new Date(_date as Date);
			const parsedDate = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
			if (name === "effective_date")
				setProvidersDetails(Object.assign({}, providersDetails, { [name]: parsedDate }));
			if (name === "termination_date")
				setProvidersDetails(Object.assign({}, providersDetails, { [name]: parsedDate }));
		},
		[providersDetails]
	);

	const handleClearDateField = useCallback(
		(event: React.MouseEvent<HTMLButtonElement, MouseEvent>, name: string) => {
			setProvidersDetails(Object.assign({}, providersDetails, { [name]: null }));
		},
		[providersDetails]
	);

	const provider_status_options = ["ACTIVE", "TERM"];
	const provider_type_options = ["DIRECT CONTRACT", "BSA"];

	useEffect(() => {
		setProviderDetailsForm(
			Object.assign(
				{},
				{
					"Edit Provider Form": [
						{
							label: "Provider Type",
							name: "provider_type",
							onChange: (event: React.ChangeEvent<HTMLInputElement>) => handleProviderInputChange(event),
							value: providersDetails.provider_type,
							type: "select",
							placeholder: "Select the provider type"
						},
						{
							label: "Provider Status",
							name: "provider_status",
							onChange: (event: React.ChangeEvent<HTMLInputElement>) => handleProviderInputChange(event),
							value: providersDetails.provider_status,
							type: "select",
							placeholder: "Select the provider status"
						},
						{
							label: "Tax Id",
							name: "tax_id",
							onChange: (event: React.ChangeEvent<HTMLInputElement>) => handleProviderInputChange(event),
							value: providersDetails.tax_id,
							type: "textfield",
							placeholder: "Enter the Tax-Id"
						},
						{
							label: "First Name",
							name: "first_name",
							onChange: (event: React.ChangeEvent<HTMLInputElement>) => handleProviderInputChange(event),
							value: providersDetails.first_name,
							type: "textfield",
							placeholder: "Enter the first Name"
						},
						{
							label: "Middle Name",
							name: "middle_name",
							onChange: (event: React.ChangeEvent<HTMLInputElement>) => handleProviderInputChange(event),
							value: providersDetails.middle_name,
							type: "textfield",
							placeholder: "Enter the Middle Name"
						},
						{
							label: "Last Name",
							name: "last_name",
							onChange: (event: React.ChangeEvent<HTMLInputElement>) => handleProviderInputChange(event),
							value: providersDetails.last_name,
							type: "textfield",
							placeholder: "Enter the Last Name"
						},
						{
							label: "Degree",
							name: "degree",
							onChange: (event: React.ChangeEvent<HTMLInputElement>) => handleProviderInputChange(event),
							value: providersDetails.degree,
							type: "textfield",
							placeholder: "Enter the Degree"
						},
						{
							label: "Contracted Through",
							name: "contracted_through",
							onChange: (event: React.ChangeEvent<HTMLInputElement>) => handleProviderInputChange(event),
							value: providersDetails.contracted_through,
							type: "textfield",
							placeholder: "Enter Contracted Through"
						},
						{
							label: "Facility Name",
							name: "facility_name",
							onChange: (event: React.ChangeEvent<HTMLInputElement>) => handleProviderInputChange(event),
							value: providersDetails.facility_name,
							type: "textfield",
							placeholder: "Enter the Facility Name"
						},
						{
							label: "Speciality",
							name: "speciality",
							onChange: (event: React.ChangeEvent<HTMLInputElement>) => handleProviderInputChange(event),
							value: providersDetails.speciality,
							type: "textfield",
							placeholder: "Enter Specility"
						},
						{
							label: "Address",
							name: "address",
							onChange: (event: React.ChangeEvent<HTMLInputElement>) => handleProviderInputChange(event),
							value: providersDetails.address,
							type: "textfield",
							placeholder: "Enter the Address"
						},
						{
							label: "City",
							name: "city",
							onChange: (event: React.ChangeEvent<HTMLInputElement>) => handleProviderInputChange(event),
							value: providersDetails.city,
							type: "textfield",
							placeholder: "Enter Contracted Through"
						},
						{
							label: "State",
							name: "state",
							onChange: (event: React.ChangeEvent<HTMLInputElement>) => handleProviderInputChange(event),
							value: providersDetails.state,
							type: "textfield",
							placeholder: "Enter the State Name"
						},
						{
							label: "ZIP",
							name: "ZIP",
							onChange: (event: React.ChangeEvent<HTMLInputElement>) => handleProviderInputChange(event),
							value: providersDetails.ZIP,
							type: "textfield",
							placeholder: "Enter the ZIP Code"
						},
						// {
						// 	label: "Latitude",
						// 	name: "latitude",
						// 	onChange: (event: React.ChangeEvent<HTMLInputElement>) => handleProviderInputChange(event),
						// 	value: providersDetails.latitude,
						// 	type: "textfield",
						// 	placeholder: "Enter the Latitude"
						// },
						// {
						// 	label: "Longitude",
						// 	name: "longitude",
						// 	onChange: (event: React.ChangeEvent<HTMLInputElement>) => handleProviderInputChange(event),
						// 	value: providersDetails.longitude,
						// 	type: "textfield",
						// 	placeholder: "Enter the Longitude"
						// },
						{
							label: "Phone Number",
							name: "phone_number",
							onChange: (event: React.ChangeEvent<HTMLInputElement>) => handleProviderInputChange(event),
							value: providersDetails.phone_number,
							type: "textfield",
							placeholder: "Enter the Phone Number"
						},
						{
							label: "Fax Number",
							name: "fax_number",
							onChange: (event: React.ChangeEvent<HTMLInputElement>) => handleProviderInputChange(event),
							value: handleFaxNumberFormat(providersDetails.fax_number),
							type: "textfield",
							placeholder: "Enter the Fax Number"
						},
						{
							label: "Effective Date",
							name: "effective_date",
							onChange: (date: MaterialUiPickersDate, name: string) => handleDateInputChange(date, name),
							value: providersDetails.effective_date,
							type: "date",
							placeholder: "Enter the Effective Date"
						},
						{
							label: "Termination Date",
							name: "termination_date",
							onChange: (date: MaterialUiPickersDate, name: string) => handleDateInputChange(date, name),
							value: providersDetails.termination_date,
							type: "date",
							placeholder: "Enter the Termination Date"
						},
						{
							label: "Fee Schedule (in Percentage %)",
							name: "fee_schedule",
							onChange: (event: React.ChangeEvent<HTMLInputElement>) => handleProviderInputChange(event),
							value: providersDetails.fee_schedule,
							type: "textfield",
							placeholder: "Enter the Fee Schedule"
						},
						{
							label: "Office Name",
							name: "office_name",
							onChange: (event: React.ChangeEvent<HTMLInputElement>) => handleProviderInputChange(event),
							value: providersDetails.office_name,
							type: "textfield",
							placeholder: "Enter the Office Name"
						}
					]
				}
			)
		);
	}, [handleDateInputChange, handleProviderInputChange, providersDetails]);

	useEffect(() => {
		setDashboardHeader(ADMIN_DASHBOARD_HEADER.edit_providers);
	}, [setDashboardHeader]);

	return (
		<div className="edit-providers-main-container">
			<Suspense fallback={<div />}>
				<SnackbarAPICall snackbarProps={snackbarAPICallProps} />
			</Suspense>
			<div className="pf-action-button-container" id="pf-action-button-container">
				<Button
					className="button-green"
					onClick={handleEditProvidersSubmitClick}
					variant="contained"
					style={{
						pointerEvents: "unset"
					}}
				>
					<span className="button-label-with-icon" style={{ width: 160, padding: 2 }}>
						Update Providers
					</span>
					<span>
						<UpdateIcon className="button-icon" />
					</span>
				</Button>
			</div>

			<Grid container spacing={1} className="pf-grid-container">
				{providerDetailsForm &&
					Object.entries(providerDetailsForm).map(([key, value], index) => {
						return (
							<div key={index}>
								<div className="pf-title">{key}</div>
								<Suspense fallback={<div />}>
									<Paper className="pf-paper-container" elevation={3} variant="outlined">
										{value.map((field, index) => {
											return (
												<Grid item key={index} xl={12} lg={12} md={12} sm={12} xs={12}>
													<Grid container spacing={1} className="pf-label" style={{}}>
														<Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
															<div className="pf-label-text" id="pf-label-text">
																{field.label}
															</div>
														</Grid>
														<Grid item xs={9} sm={9} md={9} lg={9} xl={9}>
															{field.type === "textfield" ? (
																<TextField
																	className="text-field"
																	id={"input-text-field"}
																	type="string"
																	name={field.name}
																	placeholder={field.placeholder}
																	value={field.value ? field.value : "N/A"}
																	onChange={field.onChange}
																	onPaste={(
																		event: React.ClipboardEvent<HTMLDivElement>
																	) => handlePaste(event)}
																	variant="outlined"
																	// helperText={validation.providersDetails[field.name]}
																	style={{
																		pointerEvents: "unset",
																		width: "340px",
																		borderRadius: 50
																	}}
																	InputProps={{
																		startAdornment:
																			field.name === "phone_number" ? (
																				<InputAdornment position="end">
																					<Typography>+1</Typography>
																				</InputAdornment>
																			) : null,
																		endAdornment:
																			field.name === "fee_schedule" ? (
																				<InputAdornment position="end">
																					<Typography>%</Typography>
																				</InputAdornment>
																			) : null
																	}}
																/>
															) : field.type === "select" ? (
																<>
																	<Select
																		id="text-align-options"
																		name={field.name}
																		onChange={field.onChange}
																		style={{
																			pointerEvents: "unset",
																			minWidth: 180,
																			textAlign: "left",
																			overflowY: "visible"
																		}}
																		value={field.value}
																		MenuProps={{
																			style: { zIndex: 35960 }
																		}}
																		inputProps={{
																			"aria-label": "Without label"
																		}}
																	>
																		<MenuItem value="" disabled>
																			Select Value
																		</MenuItem>
																		{field.name === "provider_status"
																			? provider_status_options.map(
																					(option, index) => {
																						return (
																							<MenuItem
																								key={index}
																								value={option}
																							>
																								{option}
																							</MenuItem>
																						);
																					}
																			  )
																			: field.name === "provider_type"
																			? provider_type_options.map(
																					(option, index) => {
																						return (
																							<MenuItem
																								key={index}
																								value={option}
																							>
																								{option}
																							</MenuItem>
																						);
																					}
																			  )
																			: null}
																	</Select>
																</>
															) : field.type === "date" ? (
																<MuiPickersUtilsProvider utils={DateFnsUtils}>
																	<KeyboardDatePicker
																		className="from-date-input"
																		id="from-date-input"
																		inputVariant="outlined"
																		label={field.label}
																		placeholder={field.placeholder}
																		name={field.name}
																		format="MM/dd/yyyy"
																		error={false}
																		value={field.value}
																		maxDate={maxDateRange}
																		readOnly={false}
																		onChange={(date: MaterialUiPickersDate) =>
																			field.onChange(date, field.name)
																		}
																		InputProps={{
																			startAdornment: (
																				<IconButton
																					onClick={(
																						event: React.MouseEvent<
																							HTMLButtonElement,
																							MouseEvent
																						>
																					) =>
																						handleClearDateField(
																							event,
																							field.name
																						)
																					}
																					style={{ order: 1 }}
																				>
																					<ClearIcon
																						color="disabled"
																						fontSize="small"
																					/>
																				</IconButton>
																			),
																			readOnly: true
																		}}
																		InputLabelProps={{
																			shrink: true
																		}}
																		//style={{ width: "340px", borderRadius: 50 }}
																		keyboardIcon={
																			<EventIcon
																				style={{
																					color: "#7cb342"
																				}}
																			/>
																		}
																		KeyboardButtonProps={{
																			"aria-label": "change date"
																		}}
																		style={{
																			// cursor: !isButtonSelected ? "not-allowed" : "pointer",
																			pointerEvents: "unset",
																			width: "340px",
																			borderRadius: 50
																		}}
																	/>
																</MuiPickersUtilsProvider>
															) : field.type === "checkbox" ? (
																<>
																	<div className="check-support" id="check-support">
																		<span>
																			<GreenCheckbox
																				onChange={field.onChange}
																				name={field.name}
																				checked={field.value}
																			/>
																		</span>
																		<span
																			className="pf-label-text"
																			id="pf-label-text"
																		>
																			{field.label}
																		</span>
																	</div>
																</>
															) : null}
														</Grid>
													</Grid>
												</Grid>
											);
										})}
									</Paper>
								</Suspense>
							</div>
						);
					})}
			</Grid>

			<div className="pf-action-button-container margin-top-action-button" id="pf-action-button-container">
				<Button
					className="button-green"
					onClick={handleEditProvidersSubmitClick}
					variant="contained"
					style={{
						pointerEvents: "unset"
					}}
				>
					<span className="button-label-with-icon" style={{ width: 160, padding: 2 }}>
						Update Providers
					</span>
					<span>
						<UpdateIcon className="button-icon" />
					</span>
				</Button>
			</div>
		</div>
	);
};

export default EditProviders;
